<template>
    <div class="">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Attendance</li>
                </ol>
                <label class="form-label"> <h4>Attendance</h4></label>
            </div>
            <div class="d-flex">
                 <button class="btn d-flex align-item-center btn-success" @click="downloadExcel"><i class="ri-download-line me-1"></i>Download Attendance</button>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-6">
                <strong class="main-title mb-3">Attendance</strong>
            </div>
            <div class="col-md-6">
                <button style="float:right" class="btn d-flex align-item-center btn-success btn-sm" @click="downloadExcel">Download Attendance</button>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6">
                <div class="card br-16 card-shadow">
                    <div class="card-body">
                        <div class="input-group ">
                            <Search
                            class="mb-3 me-2"
                            :class="{ 'is-invalid': errors?.user_id }"
                            :customClass="{ 'is-invalid': errors?.user_id }"
                            :initialize="meta.user_id"
                            id="user_id"
                            label="name"
                            placeholder="Select User"
                            :data=" users"
                            @input="user => { meta.user_id = user; index(); }"
                        >
                        </Search>
                            <flatPickr class="form-control mb-3" placeholder="Select Date Range"
                                :class="{ 'is-invalid': errors?.date_time }" v-model="meta.date_time"
                                :config="config" @onChange="getSelectedDates" style="width: 200px;">
                            </flatPickr>
                            <button class="btn btn-primary mb-3" type="button" id="button-addon2" @click="index()">Search</button>

                        </div>
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>
                                            Username
                                            <!-- <div class="row">
                                                <div class="col-md-6">
                                                    <input type="datetime-local" class="form-control" name="from_date_time" />
                                                </div>
                                                <div class="col-md-6">
                                                    <button type="button" class="btn btn-primary">Search</button>
                                                </div>
                                            </div> -->

                                        </th>
                                        <th>
                                            Session Started
                                        </th>
                                        <th>
                                            Session Ended
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="usersAttendance?.length == 0">
                                        <td colspan="3" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="(userAttendance, key) in usersAttendance" :key="key" @click="getLocationValues(userAttendance?.user_id)" style="cursor: pointer;">
                                        <td style="font-size: 16px; padding: 10px;">
                                            <span>{{  key + 1 }}</span>. {{ userAttendance?.User?.name }}
                                        </td>
                                        <td>
                                            <span>{{ getSessionStartTime(userAttendance?.user_id) }}</span>
                                        </td>
                                        <td>
                                            <span>{{ getSessionEndTime(userAttendance?.user_id) }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div v-if="locations.length" style="width: 100%; height: 500px">
                    <GMapMap :center="center" :zoom="12" style="width: 100%; height: 500px">
                        <GMapMarker
                            v-for="(location, index) in locations"
                            :key="index"
                            :position="{ lat: location.lat, lng: location.lng }"
                        />
                        <GMapPolyline
                            :path="locations"
                            :options="{ strokeColor: '#FF0000', strokeOpacity: 1.0, strokeWeight: 2 }"
                        />
                    </GMapMap>
                </div>
                <div v-else-if="selectedUserId" class="card br-16 card-shadow">
                    <div class="card-body text-center text-muted py-5">
                        No location data available for this user in the selected date range.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from 'axios';
import Search from "@/components/Search.vue";
import moment from 'moment-timezone';
    export default {
        components: {
            Pagination,
            flatPickr,
            Search
        },
        data() {
            return {
                meta: {
                    date_time: "",
                    user_id: "",
                    from_date_time: moment().format("DD-MM-YYYY"),
                    to_date_time: moment().add(1, 'days').format("DD-MM-YYYY"),
                },
                usersAttendance: [],
                usersAttendanceDateTime: [],
                usersAttendanceLocation: [],
                locations: [],
                errors: [],
                users:[],
                selectedUserId: null,
                center: { lat: 12.9716, lng: 77.5946 },
                map:'',
                config: {
                    mode:'range',
                    defaultDate: [moment().format("DD-MM-YYYY"), moment().add(1, 'days').format("DD-MM-YYYY")],
                    dateFormat: 'd-m-Y',
                }

            };
        },
    mounted() {
        this.getUsers();
			this.index();
        },
    methods: {
        getUsers() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "users/getUsers" })
                    .then((response) => {
                        loader.hide();
                        console.log("RRR--",response)
                        vm.users = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            success(position) {
                console.log(position)
            },
            error(error) {
                alert(error)
            },
            getSelectedDates(dates){
				let vm = this;
				vm.meta.from_date_time = moment(dates[0]).format("DD-MM-YYYY")
				vm.meta.to_date_time = moment(dates[1]).format("DD-MM-YYYY")
			},
            formatDateForApi(date_time, isEnd = false) {
                if (!date_time) {
                    return date_time;
                }

                const parsed = moment(date_time, [
                    "DD-MM-YYYY HH:mm:ss",
                    "DD-MM-YYYY",
                    "YYYY-MM-DD HH:mm:ss",
                    "YYYY-MM-DD",
                ], true);

                if (!parsed.isValid()) {
                    return date_time;
                }

                return (isEnd ? parsed.endOf("day") : parsed.startOf("day")).format("YYYY-MM-DD HH:mm:ss");
            },
            buildAttendancePayload(user_id = this.meta.user_id) {
                return {
                    from_date_time: this.formatDateForApi(this.meta.from_date_time, false),
                    to_date_time: this.formatDateForApi(this.meta.to_date_time, true),
                    user_id: user_id || "",
                };
            },
            index() {
                let vm = this;
                const payload = vm.buildAttendancePayload();
                vm.$store.dispatch("post", { uri: "attendance/attendanceUsers", data: payload })
                .then(function (response) {
                    vm.usersAttendance = response.data.data?.attendanceStatus;
                    vm.usersAttendanceDateTime = response.data.data?.attendanceLogInTimes;
                    if (vm.usersAttendance.length > 0) {
                        vm.getLocationValues(vm.usersAttendance[0].user_id);
                    } else {
                        vm.locations = [];
                        vm.selectedUserId = null;
                    }
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            getLocationValues(user_id){
                let vm = this;
                let loader = vm.$loading.show();
                vm.selectedUserId = user_id;
                const payload = vm.buildAttendancePayload(user_id);
                vm.$store.dispatch("post", { uri: "attendancesLocation/getAttendancesLocations", data: payload })
                .then(function (response) {
                    loader.hide();
                    vm.usersAttendanceLocation = response.data.data || [];
                    const mappedLocations = vm.usersAttendanceLocation
                        .map(function(location) {
                            return {
                                lat: parseFloat(location.latitude),
                                lng: parseFloat(location.longitude),
                            };
                        })
                        .filter((location) => Number.isFinite(location.lat) && Number.isFinite(location.lng));

                    vm.locations = mappedLocations;
                    if (mappedLocations.length > 0) {
                        vm.center = { ...mappedLocations[0] };
                    }
                })
                .catch(function (error) {
                    loader.hide();
                    console.log('error:-----', error);
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },

            getSessionStartTime(user_id){
                let vm = this;
                let result = vm.usersAttendanceDateTime?.filter(function(ele) {
                    return ele.user_id == user_id;
                })
                let login_date = result[0]?.attendance_logins[0]?.from_date_time;
                return moment(login_date).format("DD-MM-YYYY hh:mm:ss A");
            },

            getSessionEndTime(user_id){
                let vm = this;
                let result = vm.usersAttendanceDateTime?.filter(function(ele) {
                    return ele.user_id == user_id;
                })
                let logout_date;
                if(result[0]?.attendance_logins?.length > 1)
                {
                    logout_date = result[0]?.attendance_logins[result[0]?.attendance_logins?.length-1].to_date_time
                }
                else{
                    logout_date = result[0]?.attendance_logins[0].to_date_time
                }
                if(logout_date){
                    return moment(logout_date).format("DD-MM-YYYY hh:mm:ss A")
                }
                else{
                    return ''
                }

            },
            async downloadExcel() {
                try {
                    const payload = this.buildAttendancePayload();
                    const response = await axios({
                        url: this.$store.getters.apiUrl + 'api/' + 'attendance/excelDownloadSessionAttendance',
                        method: 'POST',
                        responseType: 'blob',
                        headers: {
                            Authorization: "Bearer " + this.$store.getters.token,
                        },
                        data: payload,
                    });

                    // Create a link element to download the file
                    const dateTime = moment().format('DD-MM-YYYY_HH-mm-ss');
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `session_attendance_report_${dateTime}.xlsx`); // Set the file name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error('Error downloading the file', error);
                }
            },
        },
    };
</script>
